import { useState } from "react";
import { Link } from "react-router";
import { useForm, useWatch } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { ChangePasswordForm } from "./change-password-form";
import { ReauthenticateUser } from "./reauthenticate-user";
import { PasswordPolicy } from "../password-policy";
import { useChangePassword } from "../../hooks/use-change-password";
import { useTimeout } from "../../hooks/use-timeout";

const schema = yup
    .object({
        password: yup.string().required("Please enter your new password"),
    })
    .required();

export const ChangePassword = () => {
    const [reauthenticated, setReauthenticated] = useState(false);

    // If user idle for 5 mins then show reauthenticate form again
    useTimeout(reauthenticated, setReauthenticated);

    const methods = useForm({
        resolver: yupResolver(schema),
    });

    const password = useWatch({
        control: methods.control,
        name: "password",
    });

    const mutation = useChangePassword(setReauthenticated);

    const onSubmit = (data) => {
        mutation.mutate(data);
    };

    if (reauthenticated) {
        return (
            <>
                <div className="grid grid-cols-12 items-start gap-y-6">
                    <Card size="lg" className="grid grid-cols-12 gap-y-8">
                        <div className="col-span-full">
                            <h2 className="mb-3 text-xl font-semibold">
                                Enter your new password
                            </h2>
                        </div>
                        <ChangePasswordForm
                            methods={methods}
                            onSubmit={onSubmit}
                            isPending={mutation.isPending}
                        />
                        {mutation.error && (
                            <div className="col-span-full">
                                {mutation.error.code ===
                                    "auth/password-does-not-meet-requirements" && (
                                    <PasswordPolicy password={password} />
                                )}
                            </div>
                        )}
                        <div className="col-span-full">
                            <Button variant="secondary" size="sm" asChild>
                                <Link to=".." relative="path">
                                    Go back
                                </Link>
                            </Button>
                        </div>
                    </Card>
                </div>
            </>
        );
    }

    return (
        <ReauthenticateUser
            onReauthenticated={() => setReauthenticated(true)}
        />
    );
};
